module.exports = {
	"library.footer.terms_of_use": "Conditions d'utilisation",
	"library.footer.terms_and_conditions": "Conditions générales",
	"library.footer.privacy_policy": "Politique de confidentialité",
	"library.footer.get_to_know_us": "Apprendre à nous connaître",
	"library.footer.about": "À propos de",
	"library.footer.jobs": "Tâches",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Obtenir de l'aide",
	"library.footer.find_events": "Trouver des événements",
	"library.footer.top_events": "Événements populaires",
	"library.footer.host_events": "Organiser des événements",
	"library.footer.become_a_host": "Devenir un organisateur",
	"library.footer.tour": "Visiter",
	"library.footer.embeddable_widgets": "Widgets intégrables",
	"library.footer.customers": "Clients",
	"library.footer.pricing": "Tarification",
	"library.footer.get_the_onsite_app": "Télécharger l'application pour vendre et scanner des billets sur place",
	"library.footer.developers": "Développeurs",
	"library.footer.contact_us": "Contactez-nous"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/fr.json
// module id = 1580
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16